var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.2056 15.022H21.5852V29.583L33.0499 36.4994L34.8602 33.5144L25.2056 27.7629V15.022ZM36.8804 0L48 9.33114L44.9105 13.0563L33.7837 3.73003L36.8804 0ZM11.1172 0L14.2115 3.7276L3.08946 13.0563L0 9.32871L11.1172 0ZM23.9988 5.31474C18.2372 5.31507 12.7118 7.61664 8.638 11.7132C4.5642 15.8097 2.27574 21.3656 2.27606 27.1586C2.27638 32.9516 4.56545 38.5072 8.63971 42.6033C12.714 46.6994 18.2397 49.0003 24.0012 49C26.854 48.9998 29.6789 48.4347 32.3145 47.3369C34.9501 46.239 37.3449 44.63 39.362 42.6016C41.3791 40.5732 42.9792 38.1652 44.0708 35.5151C45.1623 32.8649 45.7241 30.0246 45.7239 27.1562C45.7238 24.2877 45.1617 21.4474 44.0698 18.7974C42.978 16.1474 41.3777 13.7396 39.3603 11.7114C37.3429 9.68328 34.948 8.0745 32.3123 6.97695C29.6765 5.8794 26.8516 5.31459 23.9988 5.31474ZM23.9988 44.1439C14.6822 44.1439 7.10333 36.5237 7.10333 27.1562C7.10333 17.7886 14.6822 10.1684 23.9988 10.1684C33.3154 10.1684 40.8943 17.7886 40.8943 27.1562C40.8943 36.5237 33.3154 44.1439 23.9988 44.1439Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.41f9a92402e2e402dfa717bf3ab6d13d.svg";
export { ForwardRef as ReactComponent };